import { Routes, Route, Navigate } from "react-router-dom";
import HomeLayout from "./Layout/HomeLayout";
import FillApplication from "./Pages/FillApplication";
import StatusRequest from "./Pages/StatusRequest";
import AdminLoginPage from "./Pages/AdminLoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./Layout/AdminDashboard";
// import EmployeeDashboard from "./Layout/EmployeeDashboard";
import EmployeeRequest from "./Pages/EmployeeRequest";
// import EmployeeRequestStatus from "./Layout/EmployeeRequestStatus";
import AdminAllRequests from "./Layout/AdminAllRequests";
// import GenerateInvoice from "./Pages/GenerateInvoice";

const Router = () => {
    return (
        <Routes>
            <Route path="/" element={<HomeLayout />} />
            <Route path="/request" element={<FillApplication />} />
            <Route path="/my_status" element={<StatusRequest />} />
            <Route path="/ms_login" element={<AdminLoginPage />} />

            <Route element={<ProtectedRoute />}>
                <Route path="/admin_dashboard" element={<AdminDashboard />} />
                <Route path="/all_requests" element={<AdminAllRequests />} />
            </Route>
            <Route element={<ProtectedRoute />}>
                {/* <Route path="/employee_dashboard" element={<EmployeeDashboard />} /> */}
                <Route path="/employee_request" element={<EmployeeRequest />} />
                {/* <Route path="/emp_req_status" element={<EmployeeRequestStatus />} /> */}
            </Route>
        </Routes>
    );
};

export default Router;
